import { Navigate, Outlet } from "react-router";

import { useClaims } from "@/hooks/use-claims";

/**
 * Gates the chromeless `/labelling` route (POS2-1057).
 *
 * A non-labeller who reaches it goes home; the backend refuses them anyway, but a
 * 403-shaped blank screen is a worse answer than the app they do have access to.
 */
export function LabellerRoute() {
  const { isLabeller } = useClaims();
  return isLabeller ? <Outlet /> : <Navigate to="/" replace />;
}

/**
 * The other direction: a labeller who lands anywhere inside the app shell is sent
 * to the workstation.
 *
 * "Labellers log in and see only the labelling screen, nothing else" is a PRD
 * requirement, and the sidebar is built from org permissions a labeller does not
 * have — so without this they would land on a dashboard of empty widgets and a nav
 * that 403s. A labeller who is *also* a platform admin or an org member is a real
 * person doing two jobs, and keeps the full app.
 */
export function LabellerHomeRedirect() {
  const { isLabeller, isPlatformAdmin, orgId } = useClaims();
  if (isLabeller && !isPlatformAdmin && !orgId) {
    return <Navigate to="/labelling" replace />;
  }
  return <Outlet />;
}
